import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { defaultValue as originalDefaultValue, container as originalContainer, propName as originalPropName, propType as originalPropType, right as originalRight } from 'gatsby-theme-docz/src/components/Props/styles';
export var Container = _styled("div", {
  target: "ei734zu0"
})("width:100%;overflow:auto;margin-bottom:2rem;table{width:100%;text-align:left;border-collapse:collapse;vertical-align:middle;font-size:0.9em;th,td{border-bottom:solid 1px ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, ";padding:12px 8px;min-height:68px;}th{color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray;
}, ";}td{p{margin:0;}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

if (typeof Container !== 'undefined' && Container && Container === Object(Container) && Object.isExtensible(Container) && !Container.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Container, '__filemeta', {
    configurable: true,
    value: {
      name: "Container",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var container = _objectSpread(_objectSpread({}, originalContainer), {}, {
  overflow: 'none'
});

if (typeof container !== 'undefined' && container && container === Object(container) && Object.isExtensible(container) && !container.hasOwnProperty('__filemeta')) {
  Object.defineProperty(container, '__filemeta', {
    configurable: true,
    value: {
      name: "container",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var propName = _objectSpread(_objectSpread({}, originalPropName), {}, {
  minWidth: '150px'
});

if (typeof propName !== 'undefined' && propName && propName === Object(propName) && Object.isExtensible(propName) && !propName.hasOwnProperty('__filemeta')) {
  Object.defineProperty(propName, '__filemeta', {
    configurable: true,
    value: {
      name: "propName",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var propType = _objectSpread(_objectSpread({}, originalPropType), {}, {
  minWidth: '150px'
});

if (typeof propType !== 'undefined' && propType && propType === Object(propType) && Object.isExtensible(propType) && !propType.hasOwnProperty('__filemeta')) {
  Object.defineProperty(propType, '__filemeta', {
    configurable: true,
    value: {
      name: "propType",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var right = _objectSpread(_objectSpread({}, originalRight), {}, {
  minWidth: '150px'
});

if (typeof right !== 'undefined' && right && right === Object(right) && Object.isExtensible(right) && !right.hasOwnProperty('__filemeta')) {
  Object.defineProperty(right, '__filemeta', {
    configurable: true,
    value: {
      name: "right",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var defaultValue = _objectSpread(_objectSpread({}, originalDefaultValue), {}, {
  maxWidth: '50%',
  overflow: 'hidden',
  color: function color(theme) {
    return "" + theme.colors.props.descriptionText;
  },
  '&[data-hovertext]': {
    cursor: 'help',
    whiteSpace: 'nowrap'
  },
  '&[data-hovertext] > em': {
    display: 'block',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  '&[data-hovertext]:hover::before': {
    content: 'attr(data-hovertext)',
    position: 'absolute',
    padding: '10px 20px',
    background: function background(theme) {
      return "" + theme.colors.props.descriptionBg;
    },
    color: function color(theme) {
      return "" + theme.colors.props.descriptionText;
    },
    border: function border(theme) {
      return "1px solid " + theme.colors.props.descriptionText;
    },
    borderRadius: 10,
    whiteSpace: 'pre-wrap',
    fontStyle: 'italic',
    zIndex: 10
  }
});

if (typeof defaultValue !== 'undefined' && defaultValue && defaultValue === Object(defaultValue) && Object.isExtensible(defaultValue) && !defaultValue.hasOwnProperty('__filemeta')) {
  Object.defineProperty(defaultValue, '__filemeta', {
    configurable: true,
    value: {
      name: "defaultValue",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}